var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

(function () {
    function r(e, n, t) {
        function o(i, f) {
            if (!n[i]) {
                if (!e[i]) {
                    var c = "function" == typeof require && require;if (!f && c) return c(i, !0);if (u) return u(i, !0);var a = new Error("Cannot find module '" + i + "'");throw a.code = "MODULE_NOT_FOUND", a;
                }var p = n[i] = { exports: {} };e[i][0].call(p.exports, function (r) {
                    var n = e[i][1][r];return o(n || r);
                }, p, p.exports, r, e, n, t);
            }return n[i].exports;
        }for (var u = "function" == typeof require && require, i = 0; i < t.length; i++) {
            o(t[i]);
        }return o;
    }return r;
})()({ 1: [function (require, module, exports) {
        function getRootSelector(cssClass) {
            var element = document.querySelector(cssClass);
            return element ? element.id : null;
        }

        /**
         * Управление модалкой
         */

        var StoriesModal = function () {
            function StoriesModal(params) {
                _classCallCheck(this, StoriesModal);

                this.modal = window.modal;
                this.eventPage = params.event;
                this.isDesktop = params.isDesktop;
            }

            _createClass(StoriesModal, [{
                key: "openStories",
                value: function openStories(storiesViewerService, element) {
                    this.modal.open({
                        content: { htmlDetachSelectorId: 'stories-clips' },
                        parentCssClass: this.isDesktop ? 'stories-modal-desktop' : 'stories-modal',
                        footer: null,
                        type: 'floating',
                        onBeforeClose: function onBeforeClose() {
                            storiesViewerService.stopActiveVideo();
                            storiesViewerService.resetProgressVideos();
                        },
                        onAfterShow: function onAfterShow() {
                            storiesViewerService.init();

                            var eventProperties = {};
                            eventProperties['Page'] = this.eventPage;
                            eventProperties['Click source'] = element.dataset.source || 'from_stories_block';

                            var storyEventName = this.eventPage === 'landing-country-page' ? 'show-country-stories' : 'show-hotel-stories';

                            window.brxTracking.sendAnalyticsEvent(storyEventName, eventProperties);
                            element.dataset.source = 'from_stories_block';
                        }
                    });
                }
            }]);

            return StoriesModal;
        }();

        var StoriesHighlights = function () {
            function StoriesHighlights(root) {
                _classCallCheck(this, StoriesHighlights);

                this.elems = {
                    root: root,
                    swiper: null
                };

                this.viewedStories = JSON.parse(localStorage.getItem('stories') || '[]');

                this.attachHandlers();
            }

            _createClass(StoriesHighlights, [{
                key: "attachHandlers",
                value: function attachHandlers() {
                    var _this = this;

                    document.addEventListener('DOMContentLoaded', function () {
                        _this.initSwiper();
                        _this.initViewedStories();
                    });
                }
            }, {
                key: "initSwiper",
                value: function initSwiper() {
                    var swiperContainer = this.elems.root.querySelector('.swiper-container');
                    if (swiperContainer) {
                        this.elems.swiper = new Swiper(swiperContainer, {
                            direction: "horizontal",
                            setWrapperSize: true,
                            spaceBetween: 0,
                            slidesPerView: 'auto',
                            centeredSlides: false,
                            grabCursor: true,
                            preloadImages: true,
                            lazy: {
                                loadPrevNext: true,
                                loadPrevNextAmount: 1
                            }
                        });
                    }
                }
            }, {
                key: "initViewedStories",
                value: function initViewedStories() {
                    var _this2 = this;

                    var highlights = this.elems.root.querySelectorAll('.highlight-story');
                    highlights.forEach(function (story) {
                        var storyId = story.dataset.id;
                        _this2.markNotViewed(storyId);

                        if (_this2.viewedStories.includes(storyId)) {
                            _this2.markViewedStory(storyId);
                        }
                    });
                }
            }, {
                key: "addViewedStory",
                value: function addViewedStory(storyId) {
                    if (!this.viewedStories.includes(storyId)) {
                        this.viewedStories.push(storyId);
                        localStorage.setItem('stories', JSON.stringify(this.viewedStories));
                    }
                    this.markViewedStory(storyId);
                }
            }, {
                key: "markViewedStory",
                value: function markViewedStory(id) {
                    var slide = this.elems.root.querySelector(".highlight-story[data-id=\"" + id + "\"]");
                    if (slide) {
                        var preview = slide.querySelector('.highlight-story__preview');
                        preview.classList.add('viewed');
                        preview.classList.remove('not-viewed');
                    }
                }
            }, {
                key: "markNotViewed",
                value: function markNotViewed(id) {
                    var slide = this.elems.root.querySelector(".highlight-story[data-id=\"" + id + "\"]");
                    if (slide) {
                        var preview = slide.querySelector('.highlight-story__preview');
                        preview.classList.add('not-viewed');
                    }
                }
            }]);

            return StoriesHighlights;
        }();

        var StoriesViewer = function () {
            function StoriesViewer(eventPage) {
                _classCallCheck(this, StoriesViewer);

                this.root = document.getElementById(getRootSelector('.stories-clips'));
                this.targetHighlight = null;
                this.eventPage = eventPage;

                this.storiesHighlightsService = null;
                this.sources = {};
                this.loadVideos();
                this.activePlayer = videojs('videoId', { preload: 'none', sources: [] });
                this.activeCategoryId = null;
                this.activeVideoId = null;
                this.currentTime = null; // Текущее время воспроизведения для плеера первого слайда
                this.isMutedInitialized = false; // Флаг для инициализации отключения звука
                this.shouldMuteByDefault = this.eventPage !== 'landing-country-page';

                this.attachHandlers();
            }

            _createClass(StoriesViewer, [{
                key: "attachHandlers",
                value: function attachHandlers() {
                    this.bindEventListeners();
                }
            }, {
                key: "bindEventListeners",
                value: function bindEventListeners() {
                    var _this3 = this;

                    if (this.root) {
                        var isSwiping = false;
                        var isSwipingPrev = false;
                        var startX = 0;
                        var startY = 0;

                        this.activePlayer.on('touchstart', function (event) {
                            var touch = event.touches[0]; // Берем первое касание
                            startX = touch.clientX;
                            startY = touch.clientY;
                            isSwiping = false;
                        });

                        this.activePlayer.on('touchend', function (event) {
                            var touch = event.changedTouches[0]; // Берем изменение первого касания
                            var endX = touch.clientX;
                            var endY = touch.clientY;

                            if (!isSwiping) {
                                var video = event.currentTarget;
                                var slideWidth = video.offsetWidth;
                                if (startX > slideWidth / 2) {
                                    _this3.stopActiveVideo(false);
                                    _this3.playNextVideo();
                                } else {
                                    _this3.stopActiveVideo();
                                    _this3.playPrevVideo();
                                }
                            } else {
                                // Вычисляем направление свайпа
                                var deltaX = endX - startX;
                                var deltaY = endY - startY;

                                if (Math.abs(deltaX) > Math.abs(deltaY)) {
                                    // Горизонтальный свайп вправо, влево
                                    if (deltaX > 50) {
                                        _this3.changeCategoryBySwipe(true);
                                    } else if (deltaX < -50) {
                                        _this3.changeCategoryBySwipe(false);
                                    }
                                }
                            }
                        });

                        this.activePlayer.on('touchmove', function (event) {
                            var touch = event.touches[0];
                            var deltaX = touch.clientX - startX;
                            var deltaY = touch.clientY - startY;

                            if (Math.abs(deltaX) > Math.abs(deltaY)) {
                                isSwipingPrev = deltaX > 0;
                                isSwiping = true;
                            }
                        });

                        // Обработчик для кнопки "звук"
                        var muteCheckbox = this.root.querySelector('.stories-mute input[type="checkbox"]');
                        if (muteCheckbox) {
                            muteCheckbox.addEventListener('change', function (e) {
                                var isMuted = e.target.checked;
                                _this3.activePlayer.muted(isMuted);
                            });
                        }

                        // Обработчик для кнопки "закрыть"
                        var closeButton = this.root.querySelector('.close-stories');
                        if (closeButton) {
                            closeButton.addEventListener('click', function () {
                                _this3.closeStoriesModal();
                            });
                        }

                        // Кнопка "назад" для десктопа
                        var desktopPrev = this.root.querySelector('.stories-desktop-prev');
                        if (desktopPrev) {
                            desktopPrev.addEventListener('click', function () {
                                _this3.stopActiveVideo();
                                _this3.playPrevVideo();
                            });
                        }

                        // Кнопка "вперёд" для десктопа
                        var desktopNext = this.root.querySelector('.stories-desktop-next');
                        if (desktopNext) {
                            desktopNext.addEventListener('click', function () {
                                _this3.stopActiveVideo(false);
                                _this3.playNextVideo();
                            });
                        }
                    }

                    // События для видеоплеера
                    if (this.activePlayer) {
                        if (!this.isMutedInitialized) {
                            this.activePlayer.muted(this.shouldMuteByDefault);

                            var _muteCheckbox = this.root ? this.root.querySelector('.stories-mute input[type="checkbox"]') : null;
                            if (_muteCheckbox) {
                                _muteCheckbox.checked = this.shouldMuteByDefault;
                            }

                            this.isMutedInitialized = true;
                        }

                        this.activePlayer.on('ended', function (e) {
                            _this3.playNextVideo(e.target.dataset.id);
                        });

                        this.activePlayer.on('loadstart', function (e) {
                            e.target.classList.add('allow-preloader');
                        });

                        this.activePlayer.on('canplaythrough', function (e) {
                            e.target.classList.remove('allow-preloader');
                        });

                        this.activePlayer.on('timeupdate', function (e) {
                            var player = e.target.player;
                            var currentTime = player.currentTime();
                            var totalDuration = player.duration();
                            var progressItem = document.querySelector(".progress-bar-item[data-id=\"" + e.target.dataset.id + "\"] span");

                            if (progressItem) {
                                var progress = currentTime / totalDuration * 100;
                                progressItem.style.width = progress + "%";
                            }
                        });
                    }
                }
            }, {
                key: "init",
                value: function init() {
                    if (!this.targetHighlight) {
                        return;
                    }

                    // Проверит, есть ли у нас определенный индекс клипа из плеера с первым слайдом
                    var clipIndex = this.targetHighlight.dataset.clipIndex;

                    // Проверяем, есть ли у нас текущее время воспроизведения
                    if (this.targetHighlight.dataset.currentTime) {
                        this.currentTime = parseFloat(this.targetHighlight.dataset.currentTime);
                    }

                    if (clipIndex !== undefined && this.targetHighlight.dataset.source === 'first_video_slide') {
                        var sourceArray = this.sourceList;

                        // Если у нас есть такой индекс и клип
                        if (sourceArray.length > 0 && !isNaN(parseInt(clipIndex)) && parseInt(clipIndex) < sourceArray.length) {
                            var index = parseInt(clipIndex);
                            var source = sourceArray[index];

                            if (source) {
                                this.activeCategoryId = source.categoryId;
                                this.activeVideoId = source.id;

                                if (this.activeCategoryId && this.activeVideoId) {
                                    this.setCategoryClasses();
                                    this.playVideo();
                                    return;
                                }
                            }
                        }
                    }

                    this.activeCategoryId = this.targetHighlight.dataset.categoryId;
                    this.activeVideoId = this.targetHighlight.dataset.id;

                    if (!this.activeCategoryId || !this.activeVideoId) {
                        console.error('Invalid activeCategoryId or activeVideoId:', {
                            activeCategoryId: this.activeCategoryId,
                            activeVideoId: this.activeVideoId
                        });
                        return;
                    }

                    this.setCategoryClasses();
                    this.playVideo();
                }
            }, {
                key: "closeStoriesModal",
                value: function closeStoriesModal() {
                    var modal = this.root.closest('.modal2');
                    window.modal.close('#' + modal.id);
                }
            }, {
                key: "stopActiveVideo",
                value: function stopActiveVideo() {
                    var rewindStart = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;

                    this.activePlayer.pause();
                    this.activePlayer.currentTime(0);

                    var progressBar = document.querySelector(".progress-bar-item[data-id=\"" + this.activeVideoId + "\"] span");
                    if (progressBar) {
                        progressBar.style.width = (rewindStart ? 0 : 100) + "%";
                    }
                    this.hideActiveLink();
                }
            }, {
                key: "playVideo",
                value: function playVideo() {
                    var _this4 = this;

                    var source = this.sources[this.activeVideoId];

                    this.activePlayer.el().dataset.id = this.activeVideoId;
                    this.activePlayer.src(source);

                    // Если у нас есть сохраненное время воспроизведения и видео из плеера первого слайда
                    if (this.currentTime !== null && this.targetHighlight.dataset.source === 'first_video_slide') {
                        // Устанавливаем обработчик события loadedmetadata для установки времени воспроизведения
                        this.activePlayer.one('loadedmetadata', function () {
                            // Проверяем, что текущее время не превышает длительность видео
                            if (_this4.currentTime < _this4.activePlayer.duration()) {
                                _this4.activePlayer.currentTime(_this4.currentTime);
                            }
                            // Сбрасываем сохраненное время после использования
                            _this4.currentTime = null;
                        });
                    }

                    var playPromise = this.activePlayer.play();

                    if (playPromise) {
                        playPromise.catch(function (error) {
                            if (error && error.name === 'AbortError') return;
                            if (error && error.name === 'NotAllowedError') {
                                _this4.activePlayer.muted(true);
                                var muteCheckbox = _this4.root ? _this4.root.querySelector('.stories-mute input[type="checkbox"]') : null;
                                if (muteCheckbox) muteCheckbox.checked = true;
                                var retry = _this4.activePlayer.play();
                                if (retry) retry.catch(function () {});
                                return;
                            }
                            console.error('Playback failed', error);
                            // при ошибке воспроизводить следующий сторис
                            if (error) {
                                _this4.playNextVideo();
                            }
                        });
                    }

                    this.storiesHighlightsService.addViewedStory(this.activeVideoId);
                    this.showActiveLink();
                }
            }, {
                key: "playNextVideo",
                value: function playNextVideo() {
                    var _this5 = this;

                    var index = this.sourceList.findIndex(function (source) {
                        return source.id === _this5.activeVideoId;
                    });
                    var nextSource = this.sourceList[index + 1];

                    if (!nextSource) {
                        this.closeStoriesModal();
                        return;
                    }

                    var nextCategoryId = nextSource.categoryId;
                    this.changeCategory(this.activeCategoryId, nextCategoryId);
                    this.activeVideoId = nextSource.id;
                    this.playVideo();
                }
            }, {
                key: "playPrevVideo",
                value: function playPrevVideo() {
                    var _this6 = this;

                    var index = this.sourceList.findIndex(function (source) {
                        return source.id === _this6.activeVideoId;
                    });
                    var prevSource = this.sourceList[index - 1];

                    if (prevSource) {
                        var prevCategoryId = prevSource.categoryId;
                        this.changeCategory(this.activeCategoryId, prevCategoryId);
                        this.activeVideoId = prevSource.id;
                    }
                    this.playVideo();
                }
            }, {
                key: "resetProgressVideos",
                value: function resetProgressVideos() {
                    document.querySelectorAll('.stories-progress-bar .progress-bar-item span').forEach(function (span) {
                        span.style.width = '0';
                    });
                }
            }, {
                key: "setCategoryClasses",
                value: function setCategoryClasses() {
                    document.querySelectorAll('.stories-progress-bar-category').forEach(function (category) {
                        category.classList.remove('active', 'prev', 'next');
                    });

                    var category = document.querySelector(".stories-progress-bar-category[data-category-id=\"" + this.activeCategoryId + "\"]");

                    if (!category) {
                        return; // Прерываем выполнение, если категории нет
                    }

                    category.classList.add('active');

                    var prevSibling = category.previousElementSibling;
                    while (prevSibling) {
                        prevSibling.classList.add('prev');
                        prevSibling.classList.remove('next');
                        prevSibling = prevSibling.previousElementSibling;
                    }

                    var nextSibling = category.nextElementSibling;
                    while (nextSibling) {
                        nextSibling.classList.add('next');
                        nextSibling.classList.remove('prev');
                        nextSibling = nextSibling.nextElementSibling;
                    }
                }
            }, {
                key: "resetCategoryClasses",
                value: function resetCategoryClasses() {
                    this.root.querySelectorAll('.stories-progress-bar-category').forEach(function (category) {
                        category.classList.remove('active', 'prev', 'next');
                    });
                }
            }, {
                key: "changeCategory",
                value: function changeCategory(activeCategoryId, changedCategoryId) {
                    if (changedCategoryId && activeCategoryId !== changedCategoryId) {
                        this.resetCategoryClasses();
                        this.activeCategoryId = changedCategoryId;
                        this.setCategoryClasses();
                    }
                }
            }, {
                key: "changeCategoryBySwipe",
                value: function changeCategoryBySwipe(isPrev) {
                    var activeVideoId = this.activeVideoId;
                    var activeCategoryId = this.activeCategoryId;

                    var index = this.sourceList.findIndex(function (source) {
                        return source.id === activeVideoId;
                    });
                    if (index === -1) return;
                    var sources = isPrev ? this.sourceList.slice(0, index).reverse() : this.sourceList.slice(index + 1);

                    var uniqueCategories = new Set(sources.map(function (s) {
                        return +s.categoryId;
                    }).filter(function (catId) {
                        return +catId !== +activeCategoryId;
                    }));

                    if (uniqueCategories.size === 0) {
                        return;
                    }

                    // Берем первую категорию
                    var changedCategoryId = Array.from(uniqueCategories)[0];

                    var eventProperties = {};
                    if (this.eventPage) {
                        eventProperties['Page'] = this.eventPage;
                    }
                    window.brxTracking.sendAnalyticsEvent('switch_stories', eventProperties);

                    this.stopActiveVideo(isPrev);
                    this.resetProgressVideos();
                    this.changeCategory(activeCategoryId, changedCategoryId);

                    var newVideoSource = this.sourceList.find(function (source) {
                        return +source.categoryId === +changedCategoryId;
                    });
                    if (!newVideoSource) {
                        return;
                    }

                    this.activeVideoId = newVideoSource.id;

                    try {
                        this.playVideo();
                    } catch (error) {
                        console.error('Ошибка при воспроизведении видео:', error);
                    }
                }
            }, {
                key: "loadVideos",
                value: function loadVideos() {
                    var _this7 = this;

                    this.sourceList = Array.from(document.querySelectorAll('.video-player source'), function (source) {
                        return {
                            id: source.dataset.id,
                            categoryId: source.dataset.categoryId,
                            src: source.dataset.src || source.src,
                            type: source.type
                        };
                    });
                    this.sourceList.forEach(function (source) {
                        _this7.sources[source.id] = { src: source.src, type: source.type };
                    });
                }
            }, {
                key: "showActiveLink",
                value: function showActiveLink() {
                    var activeLink = this.root.querySelector(".stories-links .stories-clip-link[data-category-id=\"" + this.activeCategoryId + "\"][data-id=\"" + this.activeVideoId + "\"]");
                    if (activeLink) {
                        activeLink.classList.add('active');
                    }
                }
            }, {
                key: "hideActiveLink",
                value: function hideActiveLink() {
                    var activeLink = this.root.querySelector('.stories-clip-link.active');
                    if (activeLink) {
                        activeLink.classList.remove('active');
                    }
                }
            }]);

            return StoriesViewer;
        }();

        var StoriesWidget = function () {
            function StoriesWidget(params) {
                _classCallCheck(this, StoriesWidget);

                this.root = document.getElementById(getRootSelector('.stories'));
                this.type = params.type;
                this.eventPage = params.eventPage;
                this.isDesktop = params.isDesktop;

                if (!this.root) return;

                this.storiesHighlightsService = new StoriesHighlights(this.root);
                this.storiesViewerService = null;
                this.viewerPromise = null;
                this.isOpening = false;
                this.videoJsUrl = params.videoJsUrl;
                this.videoJsCssUrl = params.videoJsCssUrl;
                this.modalService = new StoriesModal({
                    event: this.eventPage,
                    isDesktop: this.isDesktop
                });

                this.attachHandlers();
            }

            _createClass(StoriesWidget, [{
                key: "ensureViewer",
                value: function ensureViewer() {
                    var _this8 = this;

                    if (this.viewerPromise) return this.viewerPromise;
                    var videoScript = window.videojs ? Promise.resolve() : window.loadExternalScript(this.videoJsUrl);
                    this.viewerPromise = Promise.all([videoScript, window.loadExternalStylesheet(this.videoJsCssUrl)]).then(function () {
                        _this8.storiesViewerService = new StoriesViewer(_this8.eventPage);
                        _this8.storiesViewerService.storiesHighlightsService = _this8.storiesHighlightsService;
                        return _this8.storiesViewerService;
                    }).catch(function (error) {
                        _this8.viewerPromise = null;throw error;
                    });
                    return this.viewerPromise;
                }
            }, {
                key: "attachHandlers",
                value: function attachHandlers() {
                    this.bindEventListeners();
                }
            }, {
                key: "bindEventListeners",
                value: function bindEventListeners() {
                    var _this9 = this;

                    this.root.addEventListener('click', function (event) {
                        var button = event.target.closest('.show-stories');
                        if (!button || _this9.isOpening) return;
                        _this9.isOpening = true;
                        button.setAttribute('aria-busy', 'true');
                        _this9.ensureViewer().then(function (viewer) {
                            viewer.targetHighlight = button;
                            _this9.modalService.openStories(viewer, button);
                            _this9.storiesHighlightsService.addViewedStory(button.dataset.id);
                        }).catch(function (error) {
                            console.error('Stories player loading failed:', error);
                        }).then(function () {
                            _this9.isOpening = false;
                            button.removeAttribute('aria-busy');
                        });
                    });
                }
            }]);

            return StoriesWidget;
        }();

        window.HotelStories = StoriesWidget;
    }, {}] }, {}, [1]);